export class Bar
{
    constructor(value, color)
    {
        this.value = value;
        this.color = color;
    }

    setColor(color)
    {
        this.color = color;
    }
}